/* eslint-disable @typescript-eslint/ban-ts-comment */
// import { NewButton } from '@sympla/sympla-ui/lib/components';
import Button from '@sympla/sympla-components/Button';
import * as El from './BannerOneStopShop.css';

interface ImageSet {
  mobile?: string[];
  desktop?: string;
}

interface IButton {
  text: string;
  action: string;
  style?: string;
}

interface BannerOneStopShopProps {
  enabled: boolean;
  title: string;
  description: string;
  buttons: IButton[];
  display_on: string[];
  style: { banner?: string };
  images: ImageSet;
  order: number;
  sectionPosition: string;
  dataCreative: string;
  uuid: string;
}

function BannerOneStopShop({
  enabled,
  title,
  description,
  buttons,
  display_on,
  style,
  images,
  order,
  sectionPosition,
  dataCreative,
  uuid,
}: BannerOneStopShopProps) {
  const defineImage = (imageArray?: string[]) => (imageArray && imageArray[Math.floor(Math.random() * imageArray.length)]) || '';

  // const defineMobileImage = () => (images?.mobile && images.mobile[Math.floor(Math.random() * images.mobile.length)]) || '';

  const stripButtonLabel = (text: string) => {
    const string = text.toLowerCase().normalize('NFD');
    const regex = /[`'"~!@#$%^&*()\-+{}[\]|,./?;':]/g;
    const final = string.replace(regex, '').replace(/[\u0300-\u036f]/g, '').replace(/-| /g, '_');
    return final;
  };
  if (!(display_on.includes('web') && enabled)) return null;

  const tracking = (text: string) => {
    if (window?.dataLayer) {
      window.dataLayer.push({
        stckEventCategory: 'CardPromotional',
        stckEventLabel: `.banner-oss.uuid-${stripButtonLabel(uuid)}.button-${stripButtonLabel(text)}`,
        stckEventAction: 'click',
        event: 'stck',
      });
    }
  };

  return (
    <div
      data-bannerid={`${order}`}
      data-name={title}
      data-position={`${sectionPosition}`}
      data-creative={dataCreative}
      className={`${El.bannerOneStopShopContainer} animated fadeIn`}
    >
      <div
        className={`${El.bannerImageContainer.default} ${style?.banner ? El.bannerImageContainer.custom : ''} animated fadeIn`}
        style={{
          backgroundImage: `url(${defineImage(images?.desktop as unknown as string[])})`,
          ...(style?.banner && { customBannerStyle: style.banner }),
        }}
      >
        <div className={El.bannerContent}>
          {title && (
            <h2 className={El.bannerTitle}>{title}</h2>
          )}
          {description && (
            <h3 className={El.bannerDescription}>{description}</h3>
          )}
          {buttons && buttons.length > 0 && (
            <div className={El.bannerButtonsBox}>
              {buttons.map((btn, idx) => (
                <div
                  key={String(btn.text.replaceAll(' ', '-') + idx)}
                  className={`${El.bannerButtons.default} ${btn?.style ? El.bannerButtons.custom : ''}`}
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                  /** tracking */
                    tracking(btn.text);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                    /** tracking */
                      tracking(btn.text);
                    }
                  }}
                >
                  <Button
                    variant="text"
                    // variant={idx === 0 ? 'contained' : 'text'}
                    size="medium"
                    // @ts-ignore
                    onClick={btn?.action}
                    uppercase={false}
                  >
                    {btn?.text}
                  </Button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default BannerOneStopShop;
